export default {
  setPlaceList(state, placeList) {
    state.placeList = placeList
  },
  setPlace(state, place) {
    state.place = place
  }
}
